(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-swiper"] && !Shopify.designMode) return;
  try {
    
  
      var slidesPerView = 4;
      var spaceBetween = 50;
      var slidesPerGroup = 1;
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
          slidesPerView = 2;
          spaceBetween = 15;
          slidesPerGroup = 2;
      } 
      var swiper = new Swiper(".swiper-05", {

        spaceBetween: spaceBetween,
        slidesPerView: slidesPerView,
        slidesPerGroup:slidesPerGroup,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }
      });
  

  } catch(e) { console.error(e); }
})();
})();
